/* Zevaraat bangles add-on: when the checkbox is ticked, adds the add-on to the cart
   right before the theme's own product-form submit, so the theme's cart drawer shows both. */
(function () {
  if (window.__banglesAddonInit) return;
  window.__banglesAddonInit = true;

  function isCartForm(f) { return f && f.tagName === 'FORM' && /\/cart\/add/.test(f.getAttribute('action') || ''); }
  function boxFor(form) {
    if (!isCartForm(form)) return null;
    return form.querySelector('[data-bangles-addon]') ||
      (form.id && document.querySelector('[data-bangles-addon][data-form-id="' + form.id + '"]')) || null;
  }

  // Keep price label in sync and pre-select an add-on size matching the main product's size.
  function syncPrice(box) {
    var sel = box.querySelector('select[data-addon-variant]');
    var price = box.querySelector('[data-addon-price]');
    if (sel && price) { var o = sel.options[sel.selectedIndex]; if (o) price.textContent = o.dataset.price; }
  }
  function matchSize(box) {
    var sel = box.querySelector('select[data-addon-variant]');
    var form = box.closest('form') || document.getElementById(box.dataset.formId);
    if (!sel || !form) return;
    var idInput = form.querySelector('[name="id"]');
    var vid = idInput && idInput.value;
    var json = document.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]');
    if (!vid || !json) return;
    try {
      var v = JSON.parse(json.textContent).find(function (x) { return String(x.id) === String(vid); });
      if (!v) return;
      for (var i = 0; i < sel.options.length; i++) {
        var t = sel.options[i].dataset.title;
        if (v.options.indexOf(t) !== -1 || v.title === t) { sel.selectedIndex = i; syncPrice(box); return; }
      }
    } catch (e) {}
  }

  function init() {
    document.querySelectorAll('[data-bangles-addon]').forEach(function (box) {
      var sel = box.querySelector('select[data-addon-variant]');
      if (sel) sel.addEventListener('change', function () { sel.dataset.userPicked = '1'; syncPrice(box); });
      var form = box.closest('form') || document.getElementById(box.dataset.formId);
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput) idInput.addEventListener('change', function () { if (!sel || !sel.dataset.userPicked) matchSize(box); });
      matchSize(box);
    });
  }

  // Capture phase on document runs before the theme's own submit listener on the form.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (form.dataset.banglesAddonPass === '1') { delete form.dataset.banglesAddonPass; return; }
    var box = boxFor(form);
    if (!box) return;
    var cb = box.querySelector('[data-addon-checkbox]');
    var vInput = box.querySelector('[data-addon-variant]');
    if (!cb || !cb.checked || !vInput || !vInput.value) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.classList.contains('loading')) return;
    if (btn) btn.classList.add('loading');

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vInput.value), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res && res.status) console.warn('[bangles-addon] add-on not added:', res.description || res.message); })
      .catch(function (e) { console.warn('[bangles-addon] add-on request failed', e); })
      .finally(function () {
        if (btn) btn.classList.remove('loading');
        // Hand off to the theme: it adds the main bangle (with its variant/qty) and refreshes the cart drawer.
        form.dataset.banglesAddonPass = '1';
        if (form.requestSubmit) form.requestSubmit(btn || undefined);
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
